import View from './View';
import icons from 'url:../../img/sprite.svg';
import lakshmipatLogo from 'url:../../img/lakshmipat-logo.webp';
import uniform1 from 'url:../../img/uniform-1.png';
import uniform2 from 'url:../../img/uniform-2.png';
import uniform3 from 'url:../../img/school-accessories.png';
import user1 from 'url:../../img/user-2.jpg';
import user2 from 'url:../../img/user-3.jpg';
import user3 from 'url:../../img/user-4.jpg';
import user4 from 'url:../../img/user-5.jpg';
import feature from 'url:../../img/feature-1-min.webp';

class HomeView extends View {
  _parentElement = document.querySelector('.main');
  _errorMessage = 'Home Error Message';
  _message = 'Home Success Message';

  _generateMarkup() {
    return `
        <!-- 
      SECTION HERO
      -->
      <section class="section__hero">
        <div class="hero__text--container">
          <div class="hero__heading--container">
            <h1 class="hero__heading">For every student, every classroom.</h1>
            <!-- <h2 class="heading-hero"></h2> -->
            <h2 class="hero__heading">Real uniforms.</h2>
          </div>

          <div class="hero__btn--container">
            <!-- <a href="https://wa.me/+91" class="btn btn-hero">
              <ion-icon name="logo-whatsapp" class="icon"></ion-icon>
              <p>WhatsApp</p>
            </a> -->
            <a href="tel:+913335518195" class="btn--link hero__btn">
              <svg class="icon">
                <use xlink:href="${icons}#icon-phone"></use>
              </svg>
              <!-- <ion-icon name="call-outline" class="icon"></ion-icon> -->
              <p>Call</p>
            </a>
            <a href="mailto:pragya231006@gmail.com" class="btn--link hero__btn">
              <svg class="icon">
                <use xlink:href="${icons}#icon-envelope"></use>
              </svg>
              <!-- <ion-icon name="mail-unread-outline" class="icon"></ion-icon> -->
              <p>Mail</p>
            </a>
          </div>
          <div class="hero__description--container">
            <p class="hero__description">10,000+ school uniforms sold</p>
          </div>
        </div>
      </section>

      <!-- 
      SECTIOIN AFFILIATES
      -->
      <section class="section__affiliate" id="affiliates">
        <div class="container">
          <h2 class="affiliate__heading--clients section__heading">
            Our Affiliates
          </h2>

          <div class="affiliates">
            <div class="affiliate grid grid--3-cols">
              <div class="affiliate__logo">

                  <img
                    src="${lakshmipatLogo}"
                    alt="Lakshmipat Singhania Academy Kolkata"
                    class=""
                  />

              </div>

              <div class="affiliate__details">
                <p class="affiliate__cap">Since 1981</p>
                <p class="affiliate__name">Lakshmipat Singhania Academy</p>
                <p class="affiliate__description">Kolkata</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 
      SECTION SERVICES
      -->
      <section class="section__services" id="services">
        <div class="container">
          <h2 class="service__heading section__heading">We Provide</h2>
          <div class="services">
            <div class="service">
              <div class="service__img">
                <img src="${uniform1}" alt="school uniforms" />
              </div>
              <div class="service__detail">
                <p class="service__title">School Uniforms</p>
                <p class="service__description">
                  We provide school uniforms for students from kg to college.
                </p>
              </div>
            </div>

            <div class="service">
              <div class="service__img">
                <img src="${uniform2}" alt="Customizable  uniforms" />
              </div>
              <div class="service__detail">
                <p class="service__title">Customizable Uniforms</p>
                <p class="service__description">
                  We provide uniforms as per your requirement. You wish, we
                  customize.
                </p>
              </div>
            </div>
            <div class="service">
              <div class="service__img">
                <img
                  src="${uniform3}"
                  alt="school accessories"
                />
              </div>
              <div class="service__detail">
                <p class="service__title">School Accessories</p>
                <p class="service__description">
                  We provide accessories needed by school as well as student
                  itself.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 
      SECTION FEATURE
      -->
      <section class="section__feature" id="features">
        <div class="container">
          <h2 class="section__heading feature__heading">Why Us?</h2>
          <div class="features">
            <div class="feature grid grid--3-cols">
              <div class="feature__details">
                <div class="feature__detail">
                  <p class="feature__title">
                    <svg class="feature__icon">
                      <use xlink:href="${icons}#icon-edit"></use>
                    </svg>

                    Customization
                  </p>
                  <p class="feature__description">
                    We allow more personalisational and customisational
                    appproach for tailoring uniforms as per requirent and need
                    from school as well as student.
                  </p>
                </div>
                <div class="feature__detail">
                  <p class="feature__title">
                    <svg class="feature__icon">
                      <use xlink:href="${icons}#icon-database"></use>
                    </svg>

                    Bulk Order & fast TAT
                  </p>
                  <p class="feature__description">
                    We offer bulk orders and fast turnaround time as it is very
                    important for schools as well as students to get uniform
                    quickly. We guarantee that there will not be delays in
                    delivery from our end.
                  </p>
                </div>
              </div>
              <div class="feature__image">
                <img
                  src="${feature}"
                  alt="boy and girl with in school uniform and school bag"
                />
              </div>
              <div class="feature__details">
                <div class="feature__detail">
                  <p class="feature__title">
                    <svg class="feature__icon">
                      <use
                        xlink:href="${icons}#icon-hourglass-2"
                      ></use>
                    </svg>

                    44+ Years of Experience
                  </p>
                  <p class="feature__description">
                    We have one of the most experienced expertise in the
                    industry in tailoring high quality and durable uniforms.
                  </p>
                </div>
                <div class="feature__detail">
                  <p class="feature__title">
                    <svg class="feature__icon">
                      <use xlink:href="${icons}#icon-inr"></use>
                    </svg>

                    Competitive Pricing
                  </p>
                  <p class="feature__description">
                    We offer more competitive price for uniforms in industry.
                  </p>
                </div>
                <div class="feature__detail">
                  <p class="feature__title">
                    <svg class="feature__icon">
                      <use xlink:href="${icons}#icon-handshake-o"></use>
                    </svg>

                    Excelent Support
                  </p>
                  <p class="feature__description">
                    We provide excellent customer support till the student gets
                    the final and finished product.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 
      SECTION REVIEW
      -->
      <section class="section__review" id="reviews">
        <div class="container">
          <h2 class="section__heading review__heading">Customers' Words</h2>
          <div class="reviews__user">
            <figure class="review">
              <blockquote class="review__text">
                Excellent quality uniforms! The fabric is soft, durable, and
                comfortable for my child to wear all day — definitely worth the
                price. Highly recommend for all school wear needs!
              </blockquote>
              <figcaption class="review__user">
                <img
                  src="${user1}"
                  alt="User 1"
                  class="review__photo"
                />
                <div class="review__user--box">
                  <p class="review__user--name">Chandrima Mishra</p>
                  <p class="review__user--date">Feb 13, 2025</p>
                </div>
                <div class="review__rating">7.8</div>
              </figcaption>
            </figure>

            <figure class="review">
              <blockquote class="review__text">
                The stitching is strong, and the material feels premium. Even
                after several washes, the color and shape remain the same. Very
                happy with the purchase!
              </blockquote>
              <figcaption class="review__user">
                <img
                  src="${user2}"
                  alt="User 2"
                  class="review__photo"
                />
                <div class="review__user--box">
                  <p class="review__user--name">Shivanand</p>
                  <p class="review__user--date">Feb 13, 2025</p>
                </div>
                <div class="review__rating">9.3</div>
              </figcaption>
            </figure>
            <figure class="review">
              <blockquote class="review__text">
                The uniform fits perfectly and looks great! The uniforms look so
                neat and well-tailored.
              </blockquote>
              <figcaption class="review__user">
                <img
                  src="${user3}"
                  alt="User 3"
                  class="review__photo"
                />
                <div class="review__user--box">
                  <p class="review__user--name">Himanshu Benerjee</p>
                  <p class="review__user--date">Feb 13, 2025</p>
                </div>
                <div class="review__rating">8.2</div>
              </figcaption>
            </figure>
            <figure class="review">
              <blockquote class="review__text">
                Great job maintaining both comfort and quality! Customer service
                is amazing — they helped me choose the right size.
              </blockquote>
              <figcaption class="review__user">
                <img
                  src="${user4}"
                  alt="User 4"
                  class="review__photo"
                />
                <div class="review__user--box">
                  <p class="review__user--name">Gopinath Barnawal</p>
                  <p class="review__user--date">Feb 13, 2025</p>
                </div>
                <div class="review__rating">8.8</div>
              </figcaption>
            </figure>
          </div>
        </div>
      </section>
  `;
  }
}

export default new HomeView();
